import { compactValue } from "@/lib/screen-class";

// The landing page font scale. Each value switches at the compact boundary (`md`, 960): the smaller size below it,
// the unchanged desktop size from `md` upwards. Use it in `sx` (`sx={{fontSize: LANDING_HEADLINE}}`), not in the
// deprecated `fontSize` system prop of `Typography`.

/** Section headline, for example "Kooperation statt Konkurrenz:": 34 px below `md`, 55 px from `md`. */
export const LANDING_HEADLINE = compactValue("34px", "55px");

/** Closing headline of the last two sections ("Ihre Ansprechpartner"): 30 px below `md`, 45 px from `md`. */
export const LANDING_HEADLINE_SMALL = compactValue("30px", "45px");

/** Large body text under a section headline: 22 px below `md`, 32 px from `md`. */
export const LANDING_LEAD = compactValue("22px", "32px");

/** Title of a cooperation slide ("Problem", "Lösung", "Kundenvorteil"): 22 px below `md`, 26 px from `md`. */
export const LANDING_SLIDE_TITLE = compactValue("22px", "26px");

/** Bullet list text, card text and contact details: 18 px below `md`, 21 px from `md`. */
export const LANDING_BODY_LARGE = compactValue("18px", "21px");
